@let modal = this.modal();
@if (modal.isShowing()) {
    <dialog #dialogElement
            (cancel)="this.onCancel($event)"
            (click)="this.onDialogClick($event)"
            (close)="this.onClose()"
            (keydown)="this.onKeyDown($event)"
            (mousedown)="this.onDialogMouseDown($event)"
            [attr.data-id]="modal.id"
            [attr.data-qa]="modal.qaTag"
            [style.z-index]="this.zIndex()">
        <ng-container *ngComponentOutlet="modal.component; inputs: modal.componentInputs; injector: this.modalInjector()"/>
    </dialog>
}
